import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Heading from "../../../Components/Heading/Heading";
import fileDownload from "js-file-download";
import { APICall } from "../../../Helpers/API/APICalls";
import axios from "axios";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import {
  GetCustomerDropDown,
  getStreamOptions,
  getEnquiryEngagementNames,
  getEnquiryCreateEngagement,
  getEnquiryGridData,
  EnquiryExportToExcel,
  GetStream,
} from "../../../Helpers/API/APIEndPoints";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm from "../../../Components/InputForm/InputForm";
import { Tooltip } from "antd";

const Enquiry = () => {
  //Getting the RoleId and EmployeeId from the Context and Loader as well
  const { RoleId, EmployeeId } = getContext();
  const RoleIdArray = RoleId.split(",");
  let navigate = useNavigate();
  const [engagementName, setEngagementName] = useState("");
  const [streamsOptions, setStreamOptions] = useState<any>([]);
  const [streamValue, setStream] = useState(JSON.parse(localStorage.getItem("streamValue") || "[]"));   //deepak gupta
  const [exist, setExist] = useState(false);

  const [loader, setLoader] = useState(true);
  const [customerError, setCustomerError] = useState("");
  const [streamError, setStreamError] = useState("");

  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);

  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [customerSelectedData, setCustomer] = useState<any>(
    JSON.parse(localStorage.getItem("customerSelectedData") || "[]"));   //deepak gupta
  const [reset, setReset] = React.useState<any>(false);

  //For Storing previous EngagementNames
  const [previousEngagementNames, setEngagementNames] = useState([]);

  const { showLoader, hideLoader } = useContext(LoaderContext);

  //states for dynamic Grid
  const [page, setPage] = useState(0);
  const [EngagementEnquiryData, setEngagementEnquiryData] = useState<any>([]);
  const [isactive, setIsActive] = useState("active");

     //deepak gupta
  useEffect(() => {
      localStorage.setItem("streamValue",JSON.stringify(streamValue));
      localStorage.setItem("customerSelectedData",JSON.stringify(customerSelectedData));
    }, [streamValue, customerSelectedData]);

  useEffect(() => {

       //deepak gupta
    const clearUnwantedLocalStorage = () => {
      const keysToKeep = ["streamValue", "customerSelectedData"];
      Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    };

    clearUnwantedLocalStorage();     //deepak gupta
    onLoadApi();
  }, []);

  useEffect(() => {
    (async () => {
      let RoleIdToSend;
      let EmpId;
      if (RoleId.includes("3")) {
        RoleIdToSend = 3;
        EmpId = EmployeeId;
      } else if (RoleIdArray.includes("8")) {
        //added by mahesh on 09/10/2024
        RoleIdToSend = 8;
        EmpId = EmployeeId;
      } //added by mahesh on 09/10/2024
      else if (RoleIdArray.includes("2")) {
        RoleIdToSend = 2;
        EmpId = EmployeeId;
      }

      //Code for Data Send
      let customers = customerSelectedData.map((cust) => {
        return cust.value;
      });
      let streams = streamValue.map((cust) => {
        return cust.value;
      });

      let obj = {
        sortColumn,
        sortOrder: sortDirection,
        searchText,
        pageSize,
        start,
        count,
        CustomerIdFilter: customers.join(","),
        StreamIdFilter: streams.join(","),
        RoleId: RoleIdToSend,
        Id: EmpId,
        activeStatusId: isactive,
      };
      await GetGridData(obj);
    })();
  }, [
    start,
    sortColumn,
    sortDirection,
    searchText,
    reset,
    pageSize,
    page,
    isactive,
  ]);

  //Loading all the required data for the initial rendering
  const onLoadApi = async () => {
    await customerApiCall();
    await streamApiCall();

    setLoader(false);
  };

  //For handling grid activity and searches
  const GetGridData = async (obj) => {
    showLoader();
    const { data } = await APICall(getEnquiryGridData, "POST", obj);

    let arr = [];
    if (data.length > 0) {
      arr = [...data];
      setCount(arr[0].totalCount);
      setEngagementEnquiryData(data);
    } else {
      setStart(0);
      setCount(0);
      setPage(0);
      setEngagementEnquiryData([]);
    }
    hideLoader();
  };

  //Calling the customer api for customer dropdown
  const customerApiCall = async () => {
    let RoleIdToSend;

    if (RoleId.includes("3")) {
      RoleIdToSend = 3;
    } else if (RoleId.includes("8")) {
      RoleIdToSend = 8;
    } else if (RoleIdArray.includes("2")) {
      RoleIdToSend = 2;
    }
    let postObject = {
      RoleId: RoleIdToSend,
      Id: EmployeeId,
    };
    const { data } = await APICall(GetCustomerDropDown, "POST", postObject);

    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          abb: customer.abbreviation,
          value: customer.id,
          label: customer.customer,
        };
        customerArray.push(tempObj);
      });
      setCustomerOptions(customerArray);
    }
  };

  //Here this method calls stream Api
  const streamApiCall = async () => {
    const { data } = await APICall(GetStream, "GET");
    //console.log("stream data", data);

    if (data != undefined || data != null) {
      let streamArray = [];
      await data.map((stream: any) => {
        let tempObj = {
          value: stream.value,
          label: stream.label,
        };
        streamArray.push(tempObj);
      });
      setStreamOptions(streamArray);
    }
  };

  const ResetFunction = () => {
    setCustomer([]);
  };

  const SelectOnChange = (event, apiField) => {
    if (apiField == "customer") {
      setCustomer(event);
    }
    if (apiField === "stream") {
      setStream(event);
    }
  };
  const handleReset = () => {
    setCustomer([]);
    setStream([]);
    localStorage.removeItem("streamValue");   //deepak gupta
    localStorage.removeItem("customerSelectedData");   //deepak gupta
  };

  const handleOnSubmit = async () => {
    //Code for Data Send

    let customers = customerSelectedData.map((cust) => {
      return cust.value;
    });
    let streams = streamValue.map((cust) => {
      return cust.value;
    });

    let RoleIdToSend;
    let EmpId;
    if (RoleId.includes("3")) {
      RoleIdToSend = 3;
      EmpId = EmployeeId;
    } else if (RoleIdArray.includes("8")) {
      //added by mahesh on 09/10/2024
      RoleIdToSend = 8;
      EmpId = EmployeeId;
    } //added by mahesh on 09/10/2024
    else if (RoleIdArray.includes("2")) {
      RoleIdToSend = 2;
      EmpId = EmployeeId;
    }

    let obj = {
      sortColumn,
      sortOrder: sortDirection,
      searchText,
      pageSize,
      start,
      count,
      CustomerIdFilter: customers.join(","),
      RoleId: RoleIdToSend,
      Id: EmpId,
      StreamIdFilter: streams.join(","),
      activeStatusId: isactive,
    };
    await GetGridData(obj);
  };

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      const context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }
  const onInput = debounce((searchText) => {
    if (searchText !== null) {
      setSearchText(searchText);
    } else {
      setSearchText("");
    }
  }, 1000);
  //Options for Dynamic Grid
  const options = {
    selectableRows: "none",
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      onInput(searchText);
    },
    onColumnSortChange: async (sortColumn, sortOrder) => {
      if (sortOrder === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortOrder);
      }
      if (sortOrder === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortOrder);
      }
    },
    onChangePage: async (page) => {
      setPage(page);

      setStart(page * pageSize);
    },
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactive}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  //Grid columns for Dynamic
  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "customer",
      label: "Customer",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "engagementName",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "stream",
      label: "Stream",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "stageName",
      label: "Stage",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let funOwner =
            tableMeta.tableData[tableMeta.rowIndex].functionalOwner;
          // || RoleIdArray.includes("8") added by mahesh for operational manager
          return EmployeeId == funOwner &&
            (RoleIdArray.includes("3") || RoleIdArray.includes("8")) ? (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", { state: id });
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          ) : (
            EmployeeId == funOwner && RoleIdArray.includes("2") && (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("edit", { state: id });
                    }}
                    className="action_icon"
                  >
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            )
          );
        },
      },
    },
  ];

  //Export to Excel Function
  const ExportToExcel = async () => {
    let customerId = "";
    let streamId = "";

    if (customerSelectedData.length > 0) {
      customerId = customerSelectedData[0].value;
    }
    if (streamValue.length > 0) {
      streamId = streamValue[0].value;
    }

    let RoleIdToSend;
    let EmpId;
    if (RoleId.includes("3")) {
      RoleIdToSend = 3;
      EmpId = EmployeeId;
    } else if (RoleIdArray.includes("8")) {
      RoleIdToSend = 8;
      EmpId = EmployeeId;
    } else if (RoleIdArray.includes("2")) {
      RoleIdToSend = 2;
      EmpId = EmployeeId;
    }

    let obj = {
      sortColumn,
      sortOrder: sortDirection,
      searchText,
      pageSize: count,
      start,
      count,
      CustomerIdFilter: customerId.toString(),
      RoleId: RoleIdToSend,
      Id: EmpId,
      StreamIdFilter: streamId.toString(),
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: EnquiryExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "Enquiry.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Enquiry"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => navigate("edit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Customer</label>
                    <SelectForm
                      value={customerSelectedData}
                      onChange={(e: any) => SelectOnChange(e, "customer")}
                      options={customerOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 ">
                  <div className="form-group">
                    <label>Stream</label>

                    <SelectForm
                      key={1}
                      options={streamsOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={streamValue}
                      onChange={(event) => SelectOnChange(event, "stream")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      onClick={handleReset}
                      className="btn btn-reset"
                      // disabled={state !== null ? true : false}
                    >
                      Reset
                    </button>
                    <button onClick={handleOnSubmit} className="btn btn-submit">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            {
              <DynamicGrid
                options={options}
                data={EngagementEnquiryData || []}
                columns={gridColumns}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
};
export default Enquiry;
